import { createBrowserHistory } from 'history';
import config from "../../config";

const history = createBrowserHistory({
    basename: config.contextPath,
});

export default history;
